export default __webpack_public_path__ + "static/wheel_chair_b.f8481f869653d9d9252d3c3e18ad08b8.png";